var exports = {
  "TT": "ProfileCardUserInfo.module__userInfoContainer___Xzk3am",
  "S7": "ProfileCardUserInfo.module__nameRow___Xzk3am",
  "oo": "ProfileCardUserInfo.module__nameButton___Xzk3am",
  "uV": "ProfileCardUserInfo.module__nameButtonClickable___Xzk3am",
  "fC": "ProfileCardUserInfo.module__badgeContainer___Xzk3am",
  "NW": "ProfileCardUserInfo.module__userTagWrapper___Xzk3am",
  "Hq": "ProfileCardUserInfo.module__actionsContainer___Xzk3am",
  "Fj": "ProfileCardUserInfo.module__usernameRow___Xzk3am",
  "xO": "ProfileCardUserInfo.module__usernameButton___Xzk3am",
  "hI": "ProfileCardUserInfo.module__pronouns___Xzk3am",
  "sM": "ProfileCardUserInfo.module__srOnly___Xzk3am",
};

module.exports = exports;
